import { useState } from "react"
import { DataTypeList, useDataTypesHooks } from "../../../../../features/data-types"
import { Column, Data, FieldType, FieldValue, FormatType, SpinnerDiv, UIPermission } from "../../../../../features/ui"
import { useSystemStateHooks } from "../../../../system"
import { Vehicle } from "../../../state/types"
import { DataType } from "../../../../../tables"
import { useMeasureHooks } from "../../../../common"
import { VehicleFilters } from "./vehicleFilters"

type Props = {
    vehicles: Vehicle[]
}

export const VehicleList = (props: Props) => {
    const { vehicles } = props

    const [rows, setRows] = useState<Data[]>([])
    const [asyncDataLoaded, setAsyncDataLoaded] = useState(false)

    const { userHasPermission } = useSystemStateHooks()
    const readOnly = !userHasPermission(UIPermission.SAVE_VEHICLES)
    const { describeMeasure } = useMeasureHooks()
    const { formatCustomValue } = useDataTypesHooks()

    const setRowsState = (vehicleList: Vehicle[]) => {
        const vehiclesData = vehicleList.map(vehicle => {
            const { weight, maxLoadWeight, loadMeasures, ...data } = vehicle
            return {
                ...data,
                weight: describeMeasure(weight),
                maxLoadWeight: describeMeasure(maxLoadWeight)
            }
        })
        setRows(vehiclesData)
        setAsyncDataLoaded(true)
    }

    const columns: Column[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        },
        {
            name: 'plate',
            type: FieldType.TEXT,
            label: 'Patente',
            render: (value?: FieldValue) => formatCustomValue(value, FormatType.PLATE)
        },
        {
            name: 'weight',
            type: FieldType.TEXT,
            label: 'Peso'
        },
        {
            name: 'maxLoadWeight',
            type: FieldType.TEXT,
            label: 'Carga Máxima'
        }
    ]

    const onSearchStart = () => setAsyncDataLoaded(false)

    const onSearchDone = (dataTypes: DataType[]) => {
        setRowsState(dataTypes as Vehicle[])
    }

    const renderAsync = (element: JSX.Element) => asyncDataLoaded ? element : <SpinnerDiv />

    return (
        <>
            <VehicleFilters
                vehicles={vehicles}
                onSearchStart={onSearchStart}
                onSearchDone={onSearchDone}
            />
            {renderAsync(
                <DataTypeList
                    columns={columns}
                    rows={rows}
                    readOnly={readOnly}
                />
            )}
        </>
    )
}
